// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: #f8f9fa;
}

ion-header {
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  background: #222222;
}
ion-header ion-toolbar {
  --background: #222222;
  --color: white;
  --padding-start: 8px;
  --padding-end: 8px;
  --min-height: 64px;
}
ion-header ion-toolbar .header-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
}
ion-header ion-toolbar .header-content .header-logo {
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
  display: block;
}
ion-header ion-toolbar .back-btn, ion-header ion-toolbar .lang-btn {
  --color: white;
  --background-hover: rgba(255, 255, 255, 0.1);
  --background-activated: rgba(255, 255, 255, 0.2);
  --border-radius: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
  margin: 4px;
  z-index: 2;
}
ion-header ion-toolbar .back-btn ion-icon, ion-header ion-toolbar .lang-btn ion-icon {
  font-size: 22px;
}
ion-header ion-toolbar .lang-btn .lang-icon {
  height: 24px;
  width: 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  padding: 2px;
  transition: all 0.2s ease;
}
ion-header ion-toolbar .lang-btn .lang-icon:hover {
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.05);
}

ion-content {
  --background: #f8f9fa;
}

.header-wrap {
  padding: 25px 20px 15px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.title {
  font-family: Title;
  font-size: 32px;
  line-height: 120%;
  text-align: left;
  text-transform: uppercase;
  color: #1a1a1a;
  margin: 0 0 25px 0;
  padding: 0 16px;
  max-width: 600px;
}

.wrapper {
  padding: 0 16px 30px;
  background: #f8f9fa;
  max-width: 100%;
}
.wrapper ion-col {
  padding: 8px !important;
}
.wrapper .venue-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 8px auto;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  width: 100%;
  min-width: 280px;
  max-width: 600px;
  box-sizing: border-box;
}
.wrapper .venue-container:hover:not(.disabled) {
  transform: translateY(-4px);
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(var(--ion-color-primary-rgb), 0.2);
}
.wrapper .venue-container.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(20%);
}
.wrapper .venue-container.disabled .image-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.wrapper .venue-container .image-container {
  position: relative;
  height: 160px;
  width: 100%;
  overflow: hidden;
}
.wrapper .venue-container .image-container ion-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.wrapper .venue-container .image-container .status-overlay {
  position: absolute;
  bottom: 12px;
  right: 12px;
  z-index: 2;
}
.wrapper .venue-container .image-container .status-overlay .isOpen {
  background: linear-gradient(135deg, #34a853 0%, #137333 100%);
  color: white;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 11px;
  font-family: AppFontBold;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.wrapper .venue-container .image-container .status-overlay .isOpen.preorder {
  background: linear-gradient(135deg, #f5a623 0%, #d48806 100%);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
}
.wrapper .venue-container .image-container .status-overlay .isOpen.disabled {
  background: linear-gradient(135deg, #ea4335 0%, #d33b2c 100%);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
}
.wrapper .venue-container .container-info {
  padding: 18px;
  position: relative;
}
.wrapper .venue-container .container-info .address-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f3f4;
  margin-bottom: 15px;
}
.wrapper .venue-container .container-info .address-row .info {
  flex: 1;
}
.wrapper .venue-container .container-info .address-row .info .venue-name {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 24px;
  color: #1a1a1a;
  margin-bottom: 4px;
  font-weight: 700;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .venue-address {
  font-family: AppFont;
  font-size: 13px;
  line-height: 16px;
  color: #5f6368;
  flex: 1;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e8eaed;
  transition: all 0.2s ease;
  text-decoration: none;
  margin-left: 12px;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon:hover {
  background: #e8f0fe;
  border-color: rgba(var(--ion-color-primary-rgb), 0.3);
  transform: scale(1.05);
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon ion-icon {
  height: 18px;
  width: 18px;
  color: #5f6368;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon ion-icon:hover {
  color: var(--ion-color-primary);
}
.wrapper .venue-container .container-info .address-row .venue-info-wrapper {
  display: none;
}
.wrapper .venue-container .container-info .preorder-type {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.wrapper .venue-container .container-info .preorder-type::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(var(--ion-color-primary-rgb), 0.05) 0%, rgba(var(--ion-color-primary-rgb), 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) {
  border-color: rgba(var(--ion-color-primary-rgb), 0.4);
  transform: translateY(-2px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled)::before {
  opacity: 1;
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) .eat-icon {
  transform: scale(1.1);
  color: var(--ion-color-primary);
}
.wrapper .venue-container .container-info .preorder-type.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f5f5f5;
  border-color: #e0e0e0;
}
.wrapper .venue-container .container-info .preorder-type.disabled .eat-icon {
  color: #bdbdbd;
}
.wrapper .venue-container .container-info .preorder-type.disabled .type-title {
  color: #9e9e9e;
}
.wrapper .venue-container .container-info .preorder-type.disabled .type-description {
  color: #bdbdbd;
}
.wrapper .venue-container .container-info .preorder-type.active {
  opacity: 1;
}
.wrapper .venue-container .container-info .preorder-type:not(.active) {
  opacity: 0.7;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin-right: 12px;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
  width: 24px;
  height: 24px;
  min-width: 20px;
  min-height: 20px;
  color: #5f6368;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info {
  flex: 1;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 18px;
  color: #1a1a1a;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 700;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
  font-family: AppFont;
  font-size: 12px;
  line-height: 15px;
  color: #5f6368;
  margin: 0;
}
.wrapper .venue-container .container-info .devider {
  display: none;
}

.loading {
  height: 70vh;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}
.loading ion-spinner {
  --color: var(--ion-color-primary);
  width: 48px;
  height: 48px;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .wrapper {
    padding: 0 24px 35px;
    max-width: 720px;
    margin: 0 auto;
  }
  .wrapper .venue-container {
    max-width: 400px;
    margin: 12px auto;
  }
  .title {
    font-size: 30px;
    margin-bottom: 25px;
    padding: 0 24px;
  }
  .header-wrap {
    padding: 30px 24px 18px;
  }
}
@media (min-width: 1024px) {
  .wrapper {
    padding: 0 32px 40px;
    max-width: 1200px;
    margin: 0 auto;
  }
  .wrapper .venue-container {
    max-width: 380px;
    margin-bottom: 28px;
  }
  .wrapper .venue-container .container-info {
    padding: 24px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 14px 16px;
    margin: 12px 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
    margin-right: 16px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
    width: 26px;
    height: 26px;
    min-width: 22px;
    min-height: 22px;
    flex-shrink: 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
    font-size: 15px;
    line-height: 19px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
    font-size: 13px;
    line-height: 16px;
  }
  .title {
    font-size: 36px;
    margin-bottom: 30px;
    padding: 0 32px;
    max-width: 700px;
  }
  .header-wrap {
    padding: 35px 32px 20px;
  }
  ion-header ion-toolbar {
    --min-height: 68px;
  }
  ion-header ion-toolbar .header-content .header-logo {
    height: 36px;
  }
  ion-header ion-toolbar .back-btn, ion-header ion-toolbar .lang-btn {
    --padding-start: 16px;
    --padding-end: 16px;
  }
  ion-header ion-toolbar .back-btn ion-icon, ion-header ion-toolbar .lang-btn ion-icon {
    font-size: 24px;
  }
  ion-header ion-toolbar .lang-btn .lang-icon {
    height: 26px;
    width: 26px;
  }
}
@media (min-width: 991px) {
  .wrapper {
    padding: 0 40px 50px;
    max-width: 900px;
  }
  .wrapper .venue-container {
    max-width: 750px;
    margin-bottom: 32px;
  }
  .wrapper .venue-container .container-info {
    padding: 28px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 16px 20px;
    margin: 16px 0;
  }
  .wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) {
    transform: translateY(-3px);
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
    margin-right: 18px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
    width: 28px;
    height: 28px;
    min-width: 24px;
    min-height: 24px;
    flex-shrink: 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
    font-size: 16px;
    line-height: 20px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
    font-size: 14px;
    line-height: 18px;
  }
  .title {
    font-size: 42px;
    margin-bottom: 35px;
    padding: 0 40px;
    max-width: 750px;
  }
  .header-wrap {
    padding: 40px 40px 25px;
  }
  ion-header ion-toolbar {
    --min-height: 72px;
  }
  ion-header ion-toolbar .header-content .header-logo {
    height: 40px;
  }
  ion-header ion-toolbar .back-btn, ion-header ion-toolbar .lang-btn {
    --padding-start: 18px;
    --padding-end: 18px;
  }
  ion-header ion-toolbar .back-btn ion-icon, ion-header ion-toolbar .lang-btn ion-icon {
    font-size: 26px;
  }
  ion-header ion-toolbar .lang-btn .lang-icon {
    height: 28px;
    width: 28px;
  }
}
@media (max-width: 767px) {
  .wrapper {
    padding: 0 12px 25px;
  }
  .wrapper .venue-container {
    min-width: 280px;
    max-width: 480px;
    margin: 10px auto;
  }
  .wrapper .venue-container .container-info {
    padding: 16px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 10px 12px;
    margin: 8px 0;
  }
  .title {
    font-size: 28px;
    margin-bottom: 20px;
    padding: 0 12px;
    max-width: 480px;
  }
  .header-wrap {
    padding: 20px 12px 15px;
  }
}
@media (max-width: 480px) {
  .wrapper {
    padding: 0 8px 20px;
  }
  .wrapper .venue-container {
    min-width: 260px;
    max-width: 360px;
    margin: 8px auto;
  }
  .wrapper .venue-container .container-info {
    padding: 14px;
  }
  .wrapper .venue-container .container-info .address-row {
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 8px 10px;
  }
  .title {
    font-size: 24px;
    margin-bottom: 16px;
    padding: 0 8px;
    max-width: 360px;
  }
  .header-wrap {
    padding: 16px 8px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-venue/select-venue.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,2CAAA;EACA,mBAAA;AADD;AAGC;EACC,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAGE;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;AADH;AAGG;EACC,YAAA;EACA,WAAA;EACA,+BAAA;EACA,cAAA;AADJ;AAKE;EACC,cAAA;EACA,4CAAA;EACA,gDAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAHH;AAKG;EACC,eAAA;AAHJ;AAQG;EACC,YAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AANJ;AAQI;EACC,sCAAA;EACA,sBAAA;AANL;;AAaA;EACC,qBAAA;AAVD;;AAaA;EACC,uBAAA;EACA,6DAAA;AAVD;;AAaA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAVD;;AAaA;EACC,oBAAA;EACA,mBAAA;EACA,eAAA;AAVD;AAaC;EACC,uBAAA;AAXF;AAcC;EACC,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAZF;AAcE;EACC,2BAAA;EACA,6CAAA;EACA,qDAAA;AAZH;AAeE;EACC,YAAA;EACA,mBAAA;EACA,sBAAA;AAbH;AAgBI;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AAdL;AAmBE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAjBH;AAmBG;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AAjBJ;AAoBG;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAlBJ;AAoBI;EACC,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,0CAAA;EACA,kCAAA;UAAA,0BAAA;AAlBL;AAoBK;EACC,6DAAA;EACA,0CAAA;AAlBN;AAqBK;EACC,6DAAA;EACA,0CAAA;AAnBN;AAyBE;EACC,aAAA;EACA,kBAAA;AAvBH;AAyBG;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AAvBJ;AAyBI;EACC,OAAA;AAvBL;AAyBK;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAvBN;AA0BK;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAxBN;AA0BM;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,OAAA;AAxBP;AA2BM;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AAzBP;AA2BO;EACC,mBAAA;EACA,qDAAA;EACA,sBAAA;AAzBR;AA4BO;EACC,YAAA;EACA,WAAA;EACA,cAAA;AA1BR;AA4BQ;EACC,+BAAA;AA1BT;AAiCI;EACC,aAAA;AA/BL;AAmCG;EACC,0DAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAjCJ;AAmCI;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+HAAA;EACA,UAAA;EACA,6BAAA;AAjCL;AAoCI;EACC,qDAAA;EACA,2BAAA;EACA,2CAAA;AAlCL;AAoCK;EACC,UAAA;AAlCN;AAqCK;EACC,qBAAA;EACA,+BAAA;AAnCN;AAuCI;EACC,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AArCL;AAuCK;EACC,cAAA;AArCN;AAwCK;EACC,cAAA;AAtCN;AAyCK;EACC,cAAA;AAvCN;AA2CI;EACC,UAAA;AAzCL;AA4CI;EACC,YAAA;AA1CL;AA6CI;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AA3CL;AA6CK;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA3CN;AA6CM;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AA3CP;AA+CK;EACC,OAAA;AA7CN;AA+CM;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA7CP;AAgDM;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA9CP;AAqDG;EACC,aAAA;AAnDJ;;AAyDA;EACC,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAtDD;AAwDC;EACC,iCAAA;EACA,WAAA;EACA,YAAA;AAtDF;;AA2DA;EACC;IACC,oBAAA;IACA,gBAAA;IACA,cAAA;EAxDA;EA0DA;IACC,gBAAA;IACA,iBAAA;EAxDD;EA4DD;IACC,eAAA;IACA,mBAAA;IACA,eAAA;EA1DA;EA6DD;IACC,uBAAA;EA3DA;AACF;AA+DA;EACC;IACC,oBAAA;IACA,iBAAA;IACA,cAAA;EA7DA;EA+DA;IACC,gBAAA;IACA,mBAAA;EA7DD;EA+DC;IACC,aAAA;EA7DF;EA+DE;IACC,kBAAA;IACA,cAAA;EA7DH;EAgEI;IACC,kBAAA;EA9DL;EAgEK;IACC,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EA9DN;EAmEK;IACC,eAAA;IACA,iBAAA;EAjEN;EAoEK;IACC,eAAA;IACA,iBAAA;EAlEN;EA2ED;IACC,eAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EAzEA;EA4ED;IACC,uBAAA;EA1EA;EA8EA;IACC,kBAAA;EA5ED;EA8EC;IACC,YAAA;EA5EF;EA+EC;IACC,qBAAA;IACA,mBAAA;EA7EF;EA+EE;IACC,eAAA;EA7EH;EAiFC;IACC,YAAA;IACA,WAAA;EA/EF;AACF;AC3ZE;EDgfD;IACC,oBAAA;IACA,gBAAA;EAlFA;EAoFA;IACC,gBAAA;IACA,mBAAA;EAlFD;EAoFC;IACC,aAAA;EAlFF;EAoFE;IACC,kBAAA;IACA,cAAA;EAlFH;EAoFG;IACC,2BAAA;IACA,6CAAA;EAlFJ;EAsFI;IACC,kBAAA;EApFL;EAsFK;IACC,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EApFN;EAyFK;IACC,eAAA;IACA,iBAAA;EAvFN;EA0FK;IACC,eAAA;IACA,iBAAA;EAxFN;EAiGD;IACC,eAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EA/FA;EAkGD;IACC,uBAAA;EAhGA;EAoGA;IACC,kBAAA;EAlGD;EAoGC;IACC,YAAA;EAlGF;EAqGC;IACC,qBAAA;IACA,mBAAA;EAnGF;EAqGE;IACC,eAAA;EAnGH;EAuGC;IACC,YAAA;IACA,WAAA;EArGF;AACF;AA2GA;EACC;IACC,oBAAA;EAzGA;EA2GA;IACC,gBAAA;IACA,gBAAA;IACA,iBAAA;EAzGD;EA2GC;IACC,aAAA;EAzGF;EA2GE;IACC,kBAAA;IACA,aAAA;EAzGH;EA+GD;IACC,eAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EA7GA;EAgHD;IACC,uBAAA;EA9GA;AACF;AAkHA;EACC;IACC,mBAAA;EAhHA;EAkHA;IACC,gBAAA;IACA,gBAAA;IACA,gBAAA;EAhHD;EAkHC;IACC,aAAA;EAhHF;EAkHE;IACC,oBAAA;IACA,mBAAA;EAhHH;EAmHE;IACC,iBAAA;EAjHH;EAuHD;IACC,eAAA;IACA,mBAAA;IACA,cAAA;IACA,gBAAA;EArHA;EAwHD;IACC,sBAAA;EAtHA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tbackground: #f8f9fa;\n}\n\nion-header {\n\tbox-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);\n\tbackground: #222222;\n\n\tion-toolbar {\n\t\t--background: #222222;\n\t\t--color: white;\n\t\t--padding-start: 8px;\n\t\t--padding-end: 8px;\n\t\t--min-height: 64px;\n\t\t\n\t\t.header-content {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\tz-index: 1;\n\t\t\tpointer-events: none;\n\n\t\t\t.header-logo {\n\t\t\t\theight: 32px;\n\t\t\t\twidth: auto;\n\t\t\t\tfilter: brightness(0) invert(1);\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t\n\t\t.back-btn, .lang-btn {\n\t\t\t--color: white;\n\t\t\t--background-hover: rgba(255, 255, 255, 0.1);\n\t\t\t--background-activated: rgba(255, 255, 255, 0.2);\n\t\t\t--border-radius: 12px;\n\t\t\t--padding-start: 12px;\n\t\t\t--padding-end: 12px;\n\t\t\tmargin: 4px;\n\t\t\tz-index: 2;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 22px;\n\t\t\t}\n\t\t}\n\n\t\t.lang-btn {\n\t\t\t.lang-icon {\n\t\t\t\theight: 24px;\n\t\t\t\twidth: 24px;\n\t\t\t\tborder: 2px solid rgba(255, 255, 255, 0.3);\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tpadding: 2px;\n\t\t\t\ttransition: all 0.2s ease;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tborder-color: rgba(255, 255, 255, 0.6);\n\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-content {\n\t--background: #f8f9fa;\n}\n\n.header-wrap {\n\tpadding: 25px 20px 15px;\n\tbackground: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n}\n\n.title {\n\tfont-family: Title;\n\tfont-size: 32px;\n\tline-height: 120%;\n\ttext-align: left;\n\ttext-transform: uppercase;\n\tcolor: #1a1a1a;\n\tmargin: 0 0 25px 0;\n\tpadding: 0 16px;\n\tmax-width: 600px;\n}\n\n.wrapper {\n\tpadding: 0 16px 30px;\n\tbackground: #f8f9fa;\n\tmax-width: 100%;\n\n\t// Add spacing between venue cards\n\tion-col {\n\t\tpadding: 8px !important;\n\t}\n\n\t.venue-container {\n\t\tbackground: white;\n\t\tborder-radius: 16px;\n\t\tbox-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);\n\t\toverflow: hidden;\n\t\tmargin: 8px auto;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\t\tborder: 1px solid rgba(255, 255, 255, 0.8);\n\t\twidth: 100%;\n\t\tmin-width: 280px;\n\t\tmax-width: 600px;\n\t\tbox-sizing: border-box;\n\n\t\t&:hover:not(.disabled) {\n\t\t\ttransform: translateY(-4px);\n\t\t\tbox-shadow: 0px 16px 48px rgba(0, 0, 0, 0.12);\n\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.2);\n\t\t}\n\n\t\t&.disabled {\n\t\t\topacity: 0.6;\n\t\t\tcursor: not-allowed;\n\t\t\tfilter: grayscale(20%);\n\t\t\t\n\t\t\t.image-container {\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground: rgba(0, 0, 0, 0.2);\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.image-container {\n\t\t\tposition: relative;\n\t\t\theight: 160px;\n\t\t\twidth: 100%;\n\t\t\toverflow: hidden;\n\n\t\t\tion-img {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\n\t\t\t.status-overlay {\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 12px;\n\t\t\t\tright: 12px;\n\t\t\t\tz-index: 2;\n\n\t\t\t\t.isOpen {\n\t\t\t\t\tbackground: linear-gradient(135deg, #34a853 0%, #137333 100%);\n\t\t\t\t\tcolor: white;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tpadding: 6px 12px;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t\tbox-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);\n\t\t\t\t\tbackdrop-filter: blur(4px);\n\n\t\t\t\t\t&.preorder {\n\t\t\t\t\t\tbackground: linear-gradient(135deg, #f5a623 0%, #d48806 100%);\n\t\t\t\t\t\tbox-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t}\n\n\t\t\t\t\t&.disabled {\n\t\t\t\t\t\tbackground: linear-gradient(135deg, #ea4335 0%, #d33b2c 100%);\n\t\t\t\t\t\tbox-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.container-info {\n\t\t\tpadding: 18px;\n\t\t\tposition: relative;\n\n\t\t\t.address-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tpadding-bottom: 15px;\n\t\t\t\tborder-bottom: 1px solid #f1f3f4;\n\t\t\t\tmargin-bottom: 15px;\n\n\t\t\t\t.info {\n\t\t\t\t\tflex: 1;\n\t\t\t\t\t\n\t\t\t\t\t.venue-name {\n\t\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\tcolor: #1a1a1a;\n\t\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\n\t\t\t\t\t.venue-address-wrapper {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t\t\t.venue-address {\n\t\t\t\t\t\t\tfont-family: AppFont;\n\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t\tcolor: #5f6368;\n\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.map-icon {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\tpadding: 8px;\n\t\t\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\t\t\tbackground: #f8f9fa;\n\t\t\t\t\t\t\tborder: 1px solid #e8eaed;\n\t\t\t\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\tmargin-left: 12px;\n\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: #e8f0fe;\n\t\t\t\t\t\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.3);\n\t\t\t\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\tion-icon {\n\t\t\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\t\t\tcolor: #5f6368;\n\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.venue-info-wrapper {\n\t\t\t\t\tdisplay: none; // Hide since we moved the status to the image overlay\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.preorder-type {\n\t\t\t\tbackground: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n\t\t\t\tborder: 1px solid #e8eaed;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tpadding: 10px 12px;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\t\t\t\tposition: relative;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground: linear-gradient(135deg, rgba(var(--ion-color-primary-rgb), 0.05) 0%, rgba(var(--ion-color-primary-rgb), 0.02) 100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t\ttransition: opacity 0.3s ease;\n\t\t\t\t}\n\n\t\t\t\t&:hover:not(.disabled) {\n\t\t\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.4);\n\t\t\t\t\ttransform: translateY(-2px);\n\t\t\t\t\tbox-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\n\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.disabled {\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t\tbackground: #f5f5f5;\n\t\t\t\t\tborder-color: #e0e0e0;\n\t\t\t\t\t\n\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\tcolor: #bdbdbd;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t.type-title {\n\t\t\t\t\t\tcolor: #9e9e9e;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t.type-description {\n\t\t\t\t\t\tcolor: #bdbdbd;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\n\t\t\t\t&:not(.active) {\n\t\t\t\t\topacity: 0.7;\n\t\t\t\t}\n\n\t\t\t\t.preorder-type-item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 1;\n\n\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin-right: 12px;\n\n\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\t\tcolor: #5f6368;\n\t\t\t\t\t\t\ttransition: all 0.3s ease;\n\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.type_info {\n\t\t\t\t\t\tflex: 1;\n\n\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t\t\tcolor: #1a1a1a;\n\t\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\tfont-family: AppFont;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tline-height: 15px;\n\t\t\t\t\t\t\tcolor: #5f6368;\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.devider {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.loading {\n\theight: 70vh;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: #f8f9fa;\n\n\tion-spinner {\n\t\t--color: var(--ion-color-primary);\n\t\twidth: 48px;\n\t\theight: 48px;\n\t}\n}\n\n// Medium screens (tablets) - 2 columns\n@media (min-width: 768px) and (max-width: 1023px) {\n\t.wrapper {\n\t\tpadding: 0 24px 35px;\n\t\tmax-width: 720px;\n\t\tmargin: 0 auto;\n\n\t\t.venue-container {\n\t\t\tmax-width: 400px;\n\t\t\tmargin: 12px auto;\n\t\t}\n\t}\n\n\t.title {\n\t\tfont-size: 30px;\n\t\tmargin-bottom: 25px;\n\t\tpadding: 0 24px;\n\t}\n\n\t.header-wrap {\n\t\tpadding: 30px 24px 18px;\n\t}\n}\n\n// Large screens and desktop responsive design\n@media (min-width: 1024px) {\n\t.wrapper {\n\t\tpadding: 0 32px 40px;\n\t\tmax-width: 1200px;\n\t\tmargin: 0 auto;\n\n\t\t.venue-container {\n\t\t\tmax-width: 380px; // Optimized for 3-column layout\n\t\t\tmargin-bottom: 28px;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 24px;\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 14px 16px;\n\t\t\t\t\tmargin: 12px 0;\n\n\t\t\t\t\t.preorder-type-item {\n\t\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\t\tmargin-right: 16px;\n\n\t\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\t\twidth: 26px;\n\t\t\t\t\t\t\t\theight: 26px;\n\t\t\t\t\t\t\t\tmin-width: 22px;\n\t\t\t\t\t\t\t\tmin-height: 22px;\n\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type_info {\n\t\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\t\t\tline-height: 19px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\tfont-size: 36px;\n\t\tmargin-bottom: 30px;\n\t\tpadding: 0 32px;\n\t\tmax-width: 700px;\n\t}\n\n\t.header-wrap {\n\t\tpadding: 35px 32px 20px;\n\t}\n\n\tion-header {\n\t\tion-toolbar {\n\t\t\t--min-height: 68px;\n\n\t\t\t.header-content .header-logo {\n\t\t\t\theight: 36px;\n\t\t\t}\n\n\t\t\t.back-btn, .lang-btn {\n\t\t\t\t--padding-start: 16px;\n\t\t\t\t--padding-end: 16px;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.lang-btn .lang-icon {\n\t\t\t\theight: 26px;\n\t\t\t\twidth: 26px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include desktop {\n\t.wrapper {\n\t\tpadding: 0 40px 50px;\n\t\tmax-width: 900px;\n\n\t\t.venue-container {\n\t\t\tmax-width: 750px;\n\t\t\tmargin-bottom: 32px;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 28px;\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 16px 20px;\n\t\t\t\t\tmargin: 16px 0;\n\n\t\t\t\t\t&:hover:not(.disabled) {\n\t\t\t\t\t\ttransform: translateY(-3px);\n\t\t\t\t\t\tbox-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);\n\t\t\t\t\t}\n\n\t\t\t\t\t.preorder-type-item {\n\t\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\t\tmargin-right: 18px;\n\n\t\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\t\twidth: 28px;\n\t\t\t\t\t\t\t\theight: 28px;\n\t\t\t\t\t\t\t\tmin-width: 24px;\n\t\t\t\t\t\t\t\tmin-height: 24px;\n\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type_info {\n\t\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tline-height: 20px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\tfont-size: 42px;\n\t\tmargin-bottom: 35px;\n\t\tpadding: 0 40px;\n\t\tmax-width: 750px;\n\t}\n\n\t.header-wrap {\n\t\tpadding: 40px 40px 25px;\n\t}\n\n\tion-header {\n\t\tion-toolbar {\n\t\t\t--min-height: 72px;\n\n\t\t\t.header-content .header-logo {\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\t.back-btn, .lang-btn {\n\t\t\t\t--padding-start: 18px;\n\t\t\t\t--padding-end: 18px;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfont-size: 26px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.lang-btn .lang-icon {\n\t\t\t\theight: 28px;\n\t\t\t\twidth: 28px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Mobile specific adjustments\n@media (max-width: 767px) {\n\t.wrapper {\n\t\tpadding: 0 12px 25px;\n\n\t\t.venue-container {\n\t\t\tmin-width: 280px;\n\t\t\tmax-width: 480px;\n\t\t\tmargin: 10px auto;\n\t\t\t\n\t\t\t.container-info {\n\t\t\t\tpadding: 16px;\n\t\t\t\t\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 10px 12px;\n\t\t\t\t\tmargin: 8px 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\tfont-size: 28px;\n\t\tmargin-bottom: 20px;\n\t\tpadding: 0 12px;\n\t\tmax-width: 480px;\n\t}\n\n\t.header-wrap {\n\t\tpadding: 20px 12px 15px;\n\t}\n}\n\n// Very small screens\n@media (max-width: 480px) {\n\t.wrapper {\n\t\tpadding: 0 8px 20px;\n\n\t\t.venue-container {\n\t\t\tmin-width: 260px;\n\t\t\tmax-width: 360px;\n\t\t\tmargin: 8px auto;\n\t\t\t\n\t\t\t.container-info {\n\t\t\t\tpadding: 14px;\n\t\t\t\t\n\t\t\t\t.address-row {\n\t\t\t\t\tpadding-bottom: 12px;\n\t\t\t\t\tmargin-bottom: 12px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 8px 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\tfont-size: 24px;\n\t\tmargin-bottom: 16px;\n\t\tpadding: 0 8px;\n\t\tmax-width: 360px;\n\t}\n\n\t.header-wrap {\n\t\tpadding: 16px 8px 12px;\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
